interface Props {
    size: string;
    color: string;
}

export const Spinner = ({size, color}: Props) => {
    return (
        <span style={{
            width: size,
            height: size,
            border: `4px solid ${color}`,
            borderBottomColor: 'transparent',
            borderRadius: '50%',
            display: 'inline-block',
            boxSizing: 'border-box',
            animation: 'rotation 1s linear infinite'
        }}></span>
    )
}
